export const locale = {
  lang: 'de',
  data: {
    'CONTRO_ENCU': {
      'TIT_ENCABE':'Umfragekontrolle',
      'CHAN_INFO':'Laden von Informationen',
      'TEX_INTRUCC':'* Suche durch Auswahl von Filter(n) durchführen',
      'SELEC_INSTI':'Institut',
      'SELEC_YEA':'Jahr',
      'SELEC_TI_ENC':'Produkte',
      'SELEC_ESTA':'Status',
      'BTN_FIL_INFO':'Erhebungen filtern',
      'COMFI_UPDA_TEX':'Sind Sie sicher, dass Sie aktualisieren wollen?/',
      'BTN_ACEP':'Akzeptieren',
      'BTN_CANC':'Abbrechen',
      'TEX_MOD_UPTD':'Aktualisieren',
      'TEX_SUCC_MOD_UPTD':'Die Aktualisierung wurde erfolgreich durchgeführt',
      'USE':'Benutzer:',
      'DAT':'Datum:',
      'ACC':'Aktion:',
      'ACC_EVENT':{
      '0':'Deaktiviert',
      '1':'Aktiviert',
    },
      'NAM_TH':{
         'TH_NAM':'Unternehmen',
         'TH_TI_ENCU':'Art der Erhebung',
         'TH_DAT_APLI':'Antragsdatum',
         'TH_ESTA':'Status',
         'TH_TOKE':'Token',
         'TH_HC':'HC',
         'TH_RESPU':'Antworten',
         'TH_DAT_CLO':'Abschlussdatum',
         'TH_PRORR':'Prolongation',
         'TH_REPO_EXC':'Excel-Bericht',
         'TH_ONLI':'Online',
         'TH_OFFLI':'Offline',
         'TH_AUDIT':'Audit',
         'TH_SECT':'Sektor',
         'TH_SUBSECT':'Teilsektor',
         'TH_LIPROY':'Projektleiter',
         'TH_JEFPROY':'Projektleiter',
      }
    },

  }
};
